import React, { useEffect, useRef, useState } from 'react';
import { WarehouseOrderExpeditionDataForm } from '../../../../../app/models/WareHouseOrderExpedition';
import { Depot } from '../../../../../app/models/Depot';
import { Place } from '../../../../../app/models/Place';
import { RouteSegment } from '../../../../../app/models/RouteSegment';
import { Currency } from '../../../../../app/models/Currency';
import { Unit } from '../../../../../app/models/Unit';
import { PackingType } from '../../../../../app/models/PackingType';
import useHandleErrorFields from '../../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../components/SelectTwo';
import { ExpeditionOptions } from '../../../../../app/models/ExpeditionOptions';

interface Props {
    expeditionDataForm: WarehouseOrderExpeditionDataForm;
    setExpeditionDataForm: (data: WarehouseOrderExpeditionDataForm) => void;
    depots: Depot[];
    origins: Place[];
    destinations: Place[];
    routeSegments: RouteSegment[];
    currencies: Currency[];
    packingTypes: PackingType[];
    expeditionOptions: ExpeditionOptions[]
    units: Unit[];
    disableUpdate?: boolean;
    errorFields?: any;

}

const WarehouseOrderExpeditionForm = ({
    expeditionDataForm,
    setExpeditionDataForm,
    depots,
    origins,
    destinations,
    routeSegments,
    currencies,
    units,
    packingTypes,
    expeditionOptions,
    disableUpdate = false,
    errorFields
}: Props) => {


    const [filteredRougeSegments, setFilteredRougeSegments] = useState<RouteSegment[]>([]);
    
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const isInitialLoad = useRef(true);

    useEffect(() => {
        if (expeditionDataForm.origin_id && expeditionDataForm.destiny_id) {
            const filtered = routeSegments.filter(
                (s) =>
                    s.origin_id === expeditionDataForm.origin_id &&
                    s.destiny_id === expeditionDataForm.destiny_id
            );
            setFilteredRougeSegments(filtered);
            
            // Solo resetear route_segment_id si NO es la carga inicial
            if (!isInitialLoad.current) {
                const currentSegmentExists = filtered.some(
                    segment => segment.id === expeditionDataForm.route_segment_id
                );
                
                if (!currentSegmentExists) {
                    setExpeditionDataForm({
                        ...expeditionDataForm,
                        route_segment_id: null
                    });
                }
            } else {
                isInitialLoad.current = false;
            }
        } else {
            setFilteredRougeSegments([]);
            if (!isInitialLoad.current) {
                setExpeditionDataForm({
                    ...expeditionDataForm,
                    route_segment_id: null
                });
            }
        }
    }, [expeditionDataForm.origin_id, expeditionDataForm.destiny_id]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setExpeditionDataForm({ ...expeditionDataForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        setExpeditionDataForm({ ...expeditionDataForm, 
            [name]: value });
    };

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();


    return (
        <>

            {/* Opciones de expedicion */}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Expediciones</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="expeditions_option_id"
                        id="expeditions_option_id"
                        inputValue={expeditionDataForm.expeditions_option_id}
                        options={SelectTwoMapperOptions(expeditionOptions,'id', ['expedition_options'])}
                        hasError={fieldHasError('expeditions_option_id') !== ''}
                        onChange={(value:any) => 
                            handleChangeSelectTwo('expeditions_option_id', value?.value)
                        }
                        placeholder="Seleccione una posicion de expedicion"
                        onFocus={() => onFocusRemove('expeditions_option_id')}
                        // disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('expeditions_option_id')}
                    </div>
                </div>
            </div>

            {/* Almacén */}
            
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Almacén</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="origin_id"
                        id="origin_id"
                        inputValue={expeditionDataForm.origin_id}
                        hasError={fieldHasError('origin_id') !== ''}
                        options={SelectTwoMapperOptions(origins, 'id', ['name'])}
                        onChange={(value:any) => 
                            handleChangeSelectTwo('origin_id', value.value)
                        }
                        placeholder="Seleccione origen"
                        onFocus={() => onFocusRemove('origin_id')}
                        disabled={disableUpdate}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('origin_id')}
                    </div>
                </div>
            </div>

            {/* Origen */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Destino</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="destiny_id"
                        id="destiny_id"
                        inputValue={expeditionDataForm.destiny_id}
                        hasError={fieldHasError('destiny_id') !== ''}
                        options={SelectTwoMapperOptions(destinations)}
                        onChange={(val) => handleChangeSelectTwo('destiny_id', val.value)}
                        placeholder="Seleccione destino"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('destiny_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('destiny_id')}
                    </div>
                </div>
            </div>

            {/* Tramo */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tramo</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="route_segment_id"
                        id="route_segment_id"
                        inputValue={expeditionDataForm.route_segment_id}
                        hasError={fieldHasError('route_segment_id') !== ''}
                        options={SelectTwoMapperOptions(filteredRougeSegments, 'id', ['name'])}
                        onChange={(val) => handleChangeSelectTwo('route_segment_id', val.value)}
                        placeholder="Seleccione tramo"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('route_segment_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('route_segment_id')}
                    </div>
                </div>
            </div>
            {/* Tramo */}
            {/* Tipo de contenedor */}

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tipo contenedor</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="packing_type_id"
                        id="packing_type_id"
                        inputValue={expeditionDataForm.packing_type_id}
                        hasError={fieldHasError('packing_type_id') !== ''}
                        options={SelectTwoMapperOptions(packingTypes)}
                        onChange={(val) => handleChangeSelectTwo('packing_type_id', val.value)}
                        placeholder="Seleccione tipo de contenedor"
                        disabled={disableUpdate}
                        onFocus={() => onFocusRemove('packing_type_id')}

                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('packing_type_id')}
                    </div>
                </div>
            </div> 
            {/* Tarifa de expedición */}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Tarifa expedición</label>
                <div className="col-md-9">
                    <div className="row g-1">
                        <div className="col-6">
                            <input
                                type="number"
                                className={`form-control ${fieldHasError('comment')}`}
                                name="rate"
                                value={expeditionDataForm.rate ?? ''}
                                onChange={handleChange}
                                placeholder="Ej: 35000"
                                disabled={disableUpdate}
                                 onFocus={() => onFocusRemove('comment')}

                            />
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="currency_id"
                                id="currency_id"
                                inputValue={expeditionDataForm.currency_id}
                                hasError={fieldHasError('currency_id') !== ''}
                                options={SelectTwoMapperOptions(currencies)}
                                onChange={(val) => handleChangeSelectTwo('currency_id', val.value)}
                                placeholder="Moneda"
                                disabled={disableUpdate}
                                onFocus={() => onFocusRemove('currency_id')}

                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('currency_id')}
                            </div>
                        </div>
                        <div className="col-3">
                            <SelectTwo
                                name="unit_id"
                                id="unit_id"
                                inputValue={expeditionDataForm.unit_id}
                                hasError={fieldHasError('unit_id') !== ''}
                                options={SelectTwoMapperOptions(units)}
                                onChange={(val) => handleChangeSelectTwo('unit_id', val.value)}
                                placeholder="Unidad"
                                disabled={disableUpdate}
                                onFocus={() => onFocusRemove('unit_id')}

                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('unit_id')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WarehouseOrderExpeditionForm;
